import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { PT } from '../components/portalUi';

// Dark, teal-accented data grid matching the portal surfaces. (Rewritten for
// MUI X DataGrid v7 — the previous rules targeted v4/v5 class names that no
// longer exist, so grids fell back to a generic grey.)
const HEADER_BG = 'rgba(56,232,255,0.08)';

export const StyledDataGrid = styled(DataGrid)(() => ({
  border: `1px solid ${PT.border}`,
  borderRadius: 14,
  color: PT.text,
  backgroundColor: 'transparent',
  fontFamily:
    'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
  WebkitFontSmoothing: 'auto',
  // v7 CSS vars (header/pinned background + row borders)
  '--DataGrid-containerBackground': HEADER_BG,
  '--DataGrid-rowBorderColor': PT.border,
  '& .MuiDataGrid-columnHeaders': { backgroundColor: HEADER_BG },
  '& .MuiDataGrid-columnHeader': { backgroundColor: HEADER_BG },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 800,
    letterSpacing: '0.03em',
    color: PT.text
  },
  '& .MuiDataGrid-iconSeparator': { display: 'none' },
  '& .MuiDataGrid-columnSeparator': { color: PT.border },
  '& .MuiDataGrid-cell': { color: PT.text, borderColor: PT.border },
  '& .MuiDataGrid-row:hover': { backgroundColor: 'rgba(56,232,255,0.07)' },
  '& .MuiDataGrid-footerContainer': { borderTop: `1px solid ${PT.border}` },
  '& .MuiDataGrid-overlay': { backgroundColor: 'transparent', color: PT.textMuted },
  // pagination / icons / "Rows per page" text
  '& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-selectIcon, & .MuiDataGrid-menuIconButton, & .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon, & .MuiSvgIcon-root':
    { color: PT.textMuted },
  '& .MuiTablePagination-actions .Mui-disabled .MuiSvgIcon-root': {
    color: 'rgba(159,176,196,0.35)'
  },
  '& .MuiPaginationItem-root': { borderRadius: 8 }
}));
